import { useMemo } from "react";
import { useAdminUsers } from "../../../lib/api/admin.api";
import { formatRelativeDate, formatShortDate } from "../../../shared/helpers/format-date";

export function AdminActivityTab() {
  const { data: users, isLoading } = useAdminUsers();

  const recentSignups = useMemo(() => {
    if (!users) return [];
    return [...users]
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
      .slice(0, 20);
  }, [users]);

  const recentlyActive = useMemo(() => {
    if (!users) return [];
    return [...users]
      .filter((u) => u.lastActiveAt)
      .sort((a, b) => new Date(b.lastActiveAt!).getTime() - new Date(a.lastActiveAt!).getTime())
      .slice(0, 20);
  }, [users]);

  if (isLoading) return <p className="text-ink-muted text-sm">Chargement...</p>;

  return (
    <div className="flex flex-col gap-6">
      {/* Dernières inscriptions */}
      <section>
        <h3 className="text-sm font-semibold text-ink mb-3">Dernières inscriptions</h3>
        <div className="flex flex-col gap-1">
          {recentSignups.map((user) => (
            <div key={user.id} className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-surface-alt/50">
              <div className="w-7 h-7 rounded-full bg-accent/15 flex items-center justify-center text-[11px] font-bold text-accent shrink-0">
                {user.name.charAt(0).toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-sm text-ink font-medium truncate block">{user.name}</span>
                <span className="text-[11px] text-ink-muted">{user.email}</span>
              </div>
              <div className="text-right shrink-0">
                <span className="text-[11px] text-ink-faint block">{formatShortDate(user.createdAt)}</span>
                <span className="text-[10px] text-ink-faint">{formatRelativeDate(new Date(user.createdAt))}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Dernière activité */}
      <section>
        <h3 className="text-sm font-semibold text-ink mb-3">Dernière activité</h3>
        <div className="flex flex-col gap-1">
          {recentlyActive.map((user) => (
            <div key={user.id} className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-surface-alt/50">
              <div className="w-7 h-7 rounded-full bg-surface-alt flex items-center justify-center text-[11px] font-bold text-ink-muted shrink-0">
                {user.name.charAt(0).toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-sm text-ink font-medium truncate block">{user.name}</span>
                <div className="flex gap-3 text-[10px] text-ink-faint">
                  <span>{user._count.tasks} tâches</span>
                  <span>{user._count.events} événements</span>
                  <span>{user._count.habits} habitudes</span>
                </div>
              </div>
              <span className="text-[11px] text-ink-faint shrink-0">
                {user.lastActiveAt && formatRelativeDate(new Date(user.lastActiveAt))}
              </span>
            </div>
          ))}
          {recentlyActive.length === 0 && (
            <p className="text-xs text-ink-faint px-3">Aucune activité récente</p>
          )}
        </div>
      </section>
    </div>
  );
}
